module.exports = __webpack_public_path__ + "img/_Carousel arrow@2x.a00f64b7.png";